import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Every column of a stored markup this client reads — the selection set `GET_MARKUPS`, `CREATE_MARKUP`
 * and `UPDATE_MARKUP` all share (KD-9).
 *
 * One fragment rather than three inline copies because `MarkupsResponse`
 * (`@efficiently/client-api-plans`) is derived from the query's row and the two mutations must return
 * the *same* row for the store to reconcile with it. Field-for-field identity used to be a comment
 * asking the next reader to keep three lists in step; it is now the compiler's job.
 *
 * `geometry` and `style` are the contract's opaque scalars (§3.1/§3.2) — the codec is the one place
 * their shape is known — and `imageRef` is immutable, so it is read here but never written by an
 * update (§1, KD-20).
 */
export const MARKUP_FIELDS = gql(`
	fragment MarkupFields on Markup {
		id
		sequenceNumber
		type
		geometry
		style
		text
		imageRef
	}
`);
